
import { FetchAPI_template } from "./FetchAPI_template";

export const CreateNewAppointment = async(data) => {

    const url = `${process.env.REACT_APP_SERVER}api/v1/client/appointments/new`;

    const method = "POST";
    
    const fetch_api_request = await FetchAPI_template(url,method,data);

    return fetch_api_request;
}

export const GetAllAppointments = async(token) => {

    const params = new URLSearchParams({
        project_id: process.env.REACT_APP_PROJECT_ID,
    }).toString();

    const url = `${process.env.REACT_APP_SERVER}api/v1/user/appointments/get?${params}`;

    const method = "GET";
    
    const fetch_api_request = await FetchAPI_template(url,method,null,token);

    return fetch_api_request;
}

export const CancelAppointmentById = async(data,token) => {

    const params = new URLSearchParams({
        project_id: process.env.REACT_APP_PROJECT_ID,
    }).toString();

    const url = `${process.env.REACT_APP_SERVER}api/v1/user/appointments/cancel?${params}`;

    const method = "POST";
    
    const fetch_api_request = await FetchAPI_template(url,method,data,token);

    return fetch_api_request;
}